import { GalleryItem, IDynamicNavItem } from '@topshots/core-models';
import {
  useGetProductEventsQuery,
  useGetProductQuery,
} from '../../app/api/products';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import styles from './content-product-page.module.css';
import { ModalContent, open } from '../../modal/modalSlice';
import { useAppDispatch } from '../../app/hooks';
import { GalleryPage } from '../../gallery-page/gallery-page';
import { Spinner } from '../../spinner/spinner';

export const ContentProductPage = ({
  navItem,
}: {
  navItem: IDynamicNavItem;
}) => {
  const dispatch = useAppDispatch();
  const { data, isLoading } = useGetProductQuery(navItem.id);
  const { data: events, isLoading: eventsIsLoading } = useGetProductEventsQuery(
    navItem.id
  );
  const handleAddToCart = (e: GalleryItem) => {
    dispatch(
      open({
        title: `${data?.name} for ${e.title}`,
        contentKey: ModalContent.AddToCart,
        contentPayload: {
          product: data,
          images: e.imageUrl === '' ? [] : [e],
          albumId: -1,
          eventId: e.id,
        },
      })
    );
  };
  if (isLoading) return <div>Loading...</div>;
  if (!data)
    return (
      <div>
        Product not found
        <pre>{JSON.stringify(navItem)}</pre>
      </div>
    );
  return (
    <>
      <div
        style={{
          maxWidth: '900px',
          margin: '0 auto',
        }}
      >
        <Markdown remarkPlugins={[remarkGfm]}>{data.content.content}</Markdown>
      </div>
      <div className={styles.events}>
        {eventsIsLoading ? (
          <Spinner />
        ) : (
          <GalleryPage
            onItemClicked={(item, index) => {
              handleAddToCart(item);
            }}
            items={events ?? []}
          />
        )}
      </div>
    </>
  );
};
